// Meta Pixel helpers. Every call is no-throw and targeted (trackSingle) so each
// pixel receives each event exactly once. Never pass form/user data here.
export const LEGACY_PIXEL_ID = "903577938708233";
export const NEW_PIXEL_ID = "2113432262630484";

type Fbq = (...args: unknown[]) => void;

function send(pixelId: string, event: string, params?: Record<string, string>) {
  try {
    const fbq = (window as Window & { fbq?: Fbq }).fbq;
    if (typeof fbq !== "function") return;
    if (params) fbq("trackSingle", pixelId, event, params);
    else fbq("trackSingle", pixelId, event);
  } catch {
    /* tracking must never break the page */
  }
}

/** Legacy pixel only: route-change PageView (its initial PageView is sent in index.html). */
export function trackLegacyPageView() { send(LEGACY_PIXEL_ID, "PageView"); }

/** New pixel only: PageView + ViewContent for one genuine page view. */
export function trackNewPageView() {
  send(NEW_PIXEL_ID, "PageView");
  send(NEW_PIXEL_ID, "ViewContent");
}

/** Completed native application: legacy keeps its existing params, new pixel gets a generic label. */
export function trackApplicationLead(legacyParams: Record<string, string>, label: string) {
  send(LEGACY_PIXEL_ID, "Lead", legacyParams);
  send(NEW_PIXEL_ID, "Lead", { content_name: label });
}
